import { createStore } from 'vuex'

const IntegrationBranch = false
const TestBranch = false
const TestUser = false
const addr = TestBranch ? "gt.samgk.ru" : "gt.samgk.ru" // 176.99.5.230, api-go.samgk.ru, 192.168.122.2
const protocol = "https:"

const host = IntegrationBranch ? window.location.origin : `${protocol}//${addr}`
const websocketHost = `wss://${addr}`

export default createStore({
    state: {
        ID: null,
        UserType: null,
        ASUToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NzQwNjYxNjksImlhdCI6MTY3NDAzMDE2OSwibG9naW4iOiJzeXN0ZW0ifQ.RnpWtU0f30vps0LsKiSlW531a5vLy1YhvOHp1VEAy6I",
        chatSendCD: 1,
        chatStatus: Object.freeze({
            A: "alive",
            F: "finished"
        }),
        chatLink: null,
        adminRole: "637a0851c14a029c30c5f21a",
        operatorRole: "63bbb103b1a2a07bbf6e00ae",
        mainOperatorRole: "63bbb115b1a2a07bbf6e00af",
        apiAddr: `${host}/support_api`,
        supportApiAddr: `${host}/support_api`,
        adminApiAddr: `${host}/support_api`,
        filesApiAddr: `${host}/support_api`,
        wsAddr: `${websocketHost}/support_api`,
        token: null,
        token_expires: null,
        mode: 'light',
    },
    mutations: {
        updateToken(state) {
            state.token = localStorage.getItem("tok")
        },
        setToken(state, token) {
            localStorage.setItem("tok", token)
            state.token = localStorage.getItem("tok")
        },
        clearToken(state) {
            localStorage.removeItem("tok")
            state.token = localStorage.getItem("tok")
        },
        updateTokenExpiration(state) {
            state.token_expires = localStorage.getItem("tok_expires")
        },
        setTokenExpiration(state, expiration) {
            localStorage.setItem("tok_expires", expiration)
            state.token_expires = localStorage.getItem("tok_expires")
        },
        clearTokenExpiration(state) {
            localStorage.removeItem("tok_expires")
            state.token_expires = localStorage.getItem("tok_expires")
        },
        setMode(state, mode) {
            localStorage.setItem("mode", mode)
            state.mode = localStorage.getItem("mode")
        },
        updateMode(state) {
            const mode = localStorage.getItem("mode")
            if (mode !== null) {
                state.mode = mode
            }
        },
        setUserID(state, id) {
            state.ID = id
        },
        updateUserID(state) {
            if (TestUser) {
                state.ID = localStorage.getItem("user_id") != null ? localStorage.getItem("user_id") : "701"
                localStorage.setItem("user_id", state.ID)
                return
            }
            // not for dev
            state.ID = asuID !== undefined && asuID !== null ? asuID : null
        },
        clearUserID(state) {
            state.ID = null
        },
        updateUserType(state) {
            if (TestUser) {
                state.UserType = localStorage.getItem("user_type") != null ? localStorage.getItem("user_type") : "asu_worker"
                localStorage.setItem("user_type", state.UserType)
                return
            }
            // not for dev
            state.UserType = userType !== undefined && userType !== null ? userType : null
        },
        setChatLink(state, obj) {
            state.chatLink = obj
        },
        clearChatLink(state) {
            state.chatLink = null
        }
    },
    actions: {},
    modules: {}
})